import { connect } from "react-redux";

import Layout from "./Layout";

export default connect((state) => {
  return {
    profile: state.auth.profile,
  };
}, {})(Layout);
